var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "40d759728c5e86aef7ce9d119071bc44.png",
    width: 227,
    height: 196
});